import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Link } from '@gto/ui/link'
import { Typography } from '@gto/ui/typography'

import { useSiteSettings } from '@/hooks/use-site-settings'

export const RootRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { settings } = useSiteSettings()

  return (
    <div className="flex flex-col gap-14 sm:gap-12">
      <div className="flex flex-col gap-8 sm:gap-6">
        <Typography
          gutterBottom
          component="h1"
          variant={isSmAndLower ? 'h5' : 'h4'}
        >
          <FormattedMessage id="common.controls.aboutUs" />
        </Typography>

        <Typography
          className="whitespace-pre-wrap"
          color="text.primary"
          variant="body1"
        >
          <FormattedMessage id="aboutUs.description" />
        </Typography>
      </div>
      <div className="flex flex-col gap-8 sm:gap-6">
        <Typography
          gutterBottom
          component="h1"
          variant={isSmAndLower ? 'h5' : 'h4'}
        >
          <FormattedMessage id="common.controls.aboutUs.CompanyInfo" />
        </Typography>
        <div className="flex flex-col gap-2">
          <Typography
            className="whitespace-pre-wrap"
            color="text.primary"
            variant="body1"
          >
            Elegant Marketing N.V.
          </Typography>
          <Typography
            className="whitespace-pre-wrap"
            color="text.primary"
            variant="body1"
          >
            19 Trias Building, Hanchi Snoa
          </Typography>
        </div>
        <div className="flex flex-col gap-2">
          <Typography
            className="whitespace-pre-wrap"
            color="text.primary"
            variant="body1"
          >
            Willemstad, Curacao
          </Typography>

          {typeof settings?.contact_email === 'string' && settings.contact_email.length > 0 && (
            <Link
              className="text-text-primary"
              href={`mailto:${settings.contact_email}`}
              underline="onHover"
            >
              {settings.contact_email}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
